import React, { useState } from 'react';
import * as Styled from "./styles";


const CustomColors = (props) => {

    const { primary_color, secondary_color } = JSON.parse(props?.value);
    const [primaryColor, setPrimaryColor] = useState(primary_color);
    const [secondaryColor, setSecondaryColor] = useState(secondary_color)

    return (
        <Styled.Container isVisible={props?.isVisible} isEnabled={props?.isEnabled}>
            <Styled.ColorContainer >
                <Styled.InputColor
                    isEnabled={props?.isEnabled}
                    type="color"
                    value={primaryColor}
                    onChange={(e) => {
                        props?.onChange(e.target.value, secondaryColor)
                        setPrimaryColor(e.target.value)
                    }
                    }
                />

                <Styled.DescriptionContainer>
                    <Styled.Description>{'Insira o hexadecimal da cor Primária'}</Styled.Description>
                    <input
                        className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500"
                        value={primaryColor}
                        onChange={(e) => {
                            props?.onChange(e.target.value, secondaryColor)
                            setPrimaryColor(e.target.value)
                        }
                        }
                    />
                </Styled.DescriptionContainer>
            </Styled.ColorContainer>
            <Styled.ColorContainer >
                <Styled.InputColor
                    isEnabled={props?.isEnabled}
                    type="color" value={secondaryColor}
                    onChange={(e) => {
                        props?.onChange(primaryColor, e.target.value)
                        setSecondaryColor(e.target.value)
                    }}
                />
                <Styled.DescriptionContainer>
                    <Styled.Description>{'Insira o hexadecimal da cor Secondária'}</Styled.Description>
                    <input
                        className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500"
                        value={secondaryColor}
                        onChange={(e) => {
                            props?.onChange(primaryColor, e.target.value)
                            setSecondaryColor(e.target.value)
                        }}
                    />
                </Styled.DescriptionContainer>
            </Styled.ColorContainer>

        </Styled.Container>

    )
}

export default CustomColors;